<template>
  <!-- Main content -->
  <section class="content">
    <div class="container-fluid" v-if="seen=='list'">
        <!-- Small boxes (Stat box) -->
        <div class="row">
        	<div class="col-md-6">
        	 	<div class="input-group  pull-right">
                	<input type="text" name="message" placeholder="Buscar ..." class="form-control" style="height:34px;margin-top: 12px;" v-model="search">
                </div>
            </div>
        	<div class="col-md-6">
        		<a class="btn btn-app pull-right bg-red" @click="nuevo()">
                  	<i class="fa fa-plus "></i> Nueva
                </a>
        	</div>
        </div>
        <div class="row">
        	<div class="col-md-12">
          		  <div class="nav-tabs-custom">
	                <ul class="nav nav-tabs pull-left">
	                  <li class="active"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Activa ({{ filteredItems.length }})</a></li>
	                  <li class=""><a href="#tab_2" data-toggle="tab" aria-expanded="false">Archivo ({{ filteredEliminados.length }})</a></li>
	                </ul>
	                <div class="tab-content">
                      <div class="tab-pane active" id="tab_1">
    	                    <paginate
    	                      v-if="filteredItems.length > 0"
                              name="filteredItems"
                              :list="filteredItems"
                              :per="15"
                            >
    	                    <table class="table table-striped">
    			                  <tbody><tr>
    			                    <th>Tipo</th>
    			                    <th>Etiqueta</th>
    			                    <th>&nbsp;</th>
    			                  </tr>
    			                  <tr v-for="item in paginated('filteredItems')" v-bind:key="item._id">
    			                    <td>{{ item.tipo }}</td>
    			                    <td>{{ item.etiqueta }}</td>
    			                    <td v-if="typeof item.asset === 'undefined'">
    			                    	<button type="button" @click="cargar(item)" class="btn btn-block btn-primary btn-sm btn-edit">Editar</button>
    			                    	<i class="fas fa-times-circle" @click="remove(item)"></i>
    			                    </td>
    			                    <td v-if="typeof item.asset != 'undefined'">
    			                    	<i class="fas fa-sync"></i>&nbsp; Pendiente
    			                    </td>
    			                  </tr>
    			                </tbody>
    			             </table>
    			             </paginate>
    			             <paginate-links for="filteredItems" :async="true" class="pagination pull-right"></paginate-links>
                      </div>
                      <!-- /.tab-pane -->
                      <div class="tab-pane" id="tab_2">
                        	<paginate
    	                      v-if="filteredEliminados.length > 0"
                              name="filteredEliminados"
                              :list="filteredEliminados"
                              :per="15"
                            >
                        	<table class="table table-striped">
    			                  <tbody><tr>
    			                    <th>Tipo</th>
    			                    <th>Etiqueta</th>
    			                    <th>&nbsp;</th>
    			                  </tr>
    			                  <tr v-for="eliminado in paginated('filteredEliminados')" v-bind:key="eliminado.id">
    			                    <td>{{ eliminado.tipo }}</td>
    			                    <td>{{ eliminado.etiqueta }}</td>
    			                    <td v-if="onlineState">
    			                    	<button type="button" @click="desarchivar(eliminado)" class="btn btn-block btn-primary btn-sm btn-edit" style="max-width: 84px;">Desarchivar</button>
    			                    </td>
    			                  </tr>
    			                </tbody>
    			             </table>
    			             </paginate>
    			             <paginate-links for="filteredEliminados" :async="true" class="pagination pull-right"></paginate-links>
                      </div>
                      <!-- /.tab-pane -->
                    </div>
                </div>
                <!-- /.tab-content -->
            </div>
        </div>
        <!-- /.row -->
        <!-- Main row -->
        
        <!-- /.row (main row) -->
      </div><!-- /.container-fluid -->
      <!-- form -->
      <div class="container-fluid"  v-if="seen=='form'">
  		<div class="row">
          <div class="col-md-12" v-if="seen=='form'">
        		<a class="btn btn-app pull-right bg-red" @click="cancelar()">
                  	<i class="fa fa-times "></i> Cerrar
                </a>
          </div>
    	</div>
  		<div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Nuevo Registro</h3>
            </div>
      		
      		<form role="form">
            <div class="box-body">
               <div class="col-md-12">
                    <div class="form-group">
                    	<label>Tipo</label>
                        <select class="form-control" v-model="input.tipo" v-validate="'required'" name="tipo">
                            <option value="null">-- Seleccione --</option>
                            <option value="Chofer">Chofer</option>
                            <option value="Destino">Destino</option>
                            <option value="Deposito">Deposito</option>
                            <option value="Operador">Operador</option>
                            <option value="Proveedor">Proveedor</option>
                        </select>
                        <span class="help-block">{{ errors.first('tipo') }}</span>
                    </div>
                    <div class="form-group">
                      	<label>Etiqueta</label>
                      	<input type="text" v-model="input.etiqueta" v-validate="'required'" name="etiqueta" class="form-control">
                      	<span class="help-block">{{ errors.first('etiqueta') }}</span>
                    </div>
                    <button type="button" v-if="savebtn" @click="guardar()" class="btn btn-primary">Crear</button>
                    <button type="button" v-if="updatebtn" @click="editar(input._id)" class="btn btn-primary">Editar</button>
                    <button type="button" @click="cancelar()" class="btn btn-default">Cancelar</button>
                </div>
             </div>
             </form>
          </div>
      </div>
      <!-- end form -->
      
  </section>
  <!-- /.content -->
</template>

<script>
/* eslint-disable */
import axios from "axios";

export default {
	data () {
		return {
			items: [],
			eliminados: [],
			paginate: ['filteredItems', 'filteredEliminados'],
			seen: 'list',
			savebtn: true,
			updatebtn: false,
			input: {
				'_id': '',
				'tipo': null,
				'etiqueta': '',
				'accion': ''
			},
			token: window.localStorage.getItem('token'),
			onlineState: navigator.onLine,
			tipoItem: 'etiqueta',
			urlAPI: 'https://data.sima-api.com/shaleetiquetas',
			search: ''
		}
	},
	methods: {
    	show (component) {
			this.seen = component
    	},
    	listar() {
    		this.show('list')
        },
        cancelar() {
    		this.clearForm
        	this.show('list')
        },
    	nuevo() {
    		this.savebtn = true
			this.updatebtn = false
			this.show('form')
    	},
    	guardar() {
    		var vm = this
    		this.$validator.validateAll().then((result) => {
    			let data = {}
				data.tipo = vm.input.tipo
				data.etiqueta = vm.input.etiqueta
				if (result) {
					if (vm.$store.state.online) {
						data.id = data._id
						axios.post(vm.urlAPI, data, {headers: {
		    		    	Authorization: 'Bearer ' +  vm.token
			    		 	}
			    		})
			    		.then(function (response) {
							data._id = response.data._id
							vm.items.unshift(data)
			    			vm.clearForm()
	        				vm.listar()
			            }).catch(function (error) {
    			           alert('Error: ' + error)
			            })
					} else {
						vm.input._id = Date.now().toString();
						data._id = vm.input._id
						data.asset = vm.tipoItem
						vm.dbAdd(vm.input, 'add')
						vm.items.unshift(data)
						vm.clearForm()
    					vm.listar()
    					
					}
    			}
    		}).catch(() => {
    		})
    	},
    	cargar (item) {
			this.input._id = item._id
    		this.input.tipo = item.tipo
    		this.input.etiqueta = item.etiqueta
    		this.savebtn = false
			this.updatebtn = true
			this.show('form')
		},
    	editar (id) {
			var vm = this
    		this.$validator.validateAll().then((result) => {
				if (result) {
					let data = {}
					data.tipo = vm.input.tipo
    				data.etiqueta = vm.input.etiqueta
					if (vm.$store.state.online) {
						axios.put(vm.urlAPI + '/' + vm.input._id, data, {headers: {
		    		    		Authorization: 'Bearer ' +  vm.token
			    		 	}
			    		})
			    		.then(function (response) {
			    			vm.clearForm()
	        				vm.listar()
			            }).catch(function (error) {
    			           alert('Error: ' + error)
			            })
					} else {
						data._id = vm.input._id
						data.asset = vm.tipoItem
						vm.dbAdd(data, 'edit')
						vm.clearForm()
    					vm.listar()
					}
					var index = vm.items.findIndex(item => item._id === vm.input._id)
					data._id = vm.input._id
					vm.items.splice(index, 1, data)
    			}
			}).catch(() => {
			})
    	},
    	remove (item) {
			if (window.confirm('Seguro desea archivar el registro')) {
				let vm = this
				if (vm.$store.state.online) {
					let data = {}
					data.Archivar = true
					axios.put(vm.urlAPI + '/' + item._id, data, {headers: {
	    		    	Authorization: 'Bearer ' +  vm.token
		    		 	}
		    		})
		    		.then(function (response) {
		    			vm.clearForm()
        				vm.listar()
		            }).catch(function (error) {
			           alert('Error: ' + error)
		            })
				} else {
					delete item.__v
					item.asset = vm.tipoItem
					vm.dbAdd(item, 'delete')
					vm.clearForm()
					vm.listar()
				}

				var index = vm.items.findIndex(itemList => itemList._id === item._id)
				vm.items.splice(index, 1)
				vm.eliminados.push(item)
			}
    	},
    	desarchivar (itemDelete) {
			var vm = this
			let data = {}
			data.tipo = itemDelete.tipo
			data.etiqueta = itemDelete.etiqueta
			data.Archivar = false
			if (vm.$store.state.online) {
				axios.put(vm.urlAPI + '/' + itemDelete._id, data, {headers: {
    		    		Authorization: 'Bearer ' +  vm.token
	    		 	}
	    		})
	    		.then(function (response) {
		    		var index = vm.eliminados.findIndex(item => item._id === itemDelete._id)
        			data._id = itemDelete._id
        			vm.eliminados.splice(index, 1)
        			vm.items.unshift(data)
	            }).catch(function (error) {
		           alert('Error: ' + error)
	            })
			} else {
				alert('Para desarchivar el registro, debe estar online')
			}
		},
    	dbAdd (item, accion) {
			item.accion = accion
			item.asset = this.tipoItem
			db.put(item).then(function(response) {
    		}).catch(function(error) {
				console.log(error)
			})
    	},
    	clearForm() {
    		this.input._id = ''
    		this.input.tipo = ''
    		this.input.etiqueta = ''
    		this.input.accion = ''
    	},
		listarAPI() {
			let vm = this
			vm.items.length = 0
			vm.items = []
			vm.eliminados.length = 0
			vm.eliminados = []

			vm.$store.commit('CLEAR_ETIQUETAS', null)
    		axios.get(vm.urlAPI + '?_sort=createdAt:desc', {headers: {
    		    	Authorization: 'Bearer ' +  vm.token
    		 	}
    		})
    		.then(function (response) {
    			for (var i = 0; i < response.data.length; i++) {
    				if(response.data[i].Archivar) {
    					vm.eliminados.push(response.data[i])
        			} else {
        				vm.items.push(response.data[i])
        				vm.$store.commit('ADD_ETIQUETA', response.data[i])
					}
    			}
            }).catch(function (error) {
                console.log(error)
            })
		}
	},
	computed: {
		isMobile () {
        	return (window.innerWidth <= 800 && window.innerHeight <= 600)
		},
		filteredItems()
	    {
	    	var self=this;
	    	return this.items.filter(function(cust){return cust.etiqueta!=null && cust.etiqueta.toLowerCase().indexOf(self.search.toLowerCase())>=0;});
	    },
	    filteredEliminados()
	    {
	    	var self=this;
	    	return this.eliminados.filter(function(cust){return cust.etiqueta!=null && cust.etiqueta.toLowerCase().indexOf(self.search.toLowerCase())>=0;});
	    },
	},
	mounted () {
		this.$nextTick(() => {})
		let vm = this
		vm.items = []
		if (vm.$store.state.online) {
			vm.listarAPI()
		} else {
			var items = vm.$store.state.etiquetas
			for (var i = 0; i < items.length; i++) {
				if(items[i].Archivar) {
					vm.eliminados.push(items[i])
				} else {
					vm.items.push(items[i])
				}
			}
		}
	},
	created () {
        this.$store.watch(
			(state)=>{
				return this.$store.state.pendientes.etiquetas
			},
			(newValue, oldValue)=>{
				this.listarAPI()
			},
			{
				deep:true
			}
		)
    },
    beforeDestroy() {
        // var todos = this.items.concat(this.eliminados)
        this.$store.commit('CLEAR_ETIQUETAS', null)
        this.$store.commit('SYNC_ETIQUETA', this.items)
    } 
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
.nav-tabs-custom>.nav-tabs.pull-left {
    float: none !important;
}
.btn-edit {
    max-width: 50px;
    float: left;
} 
.fa-times-circle {
    margin-top: 5px;
    color: crimson;
    font-size: larger;
    margin-left: 20px;
    cursor: pointer;
}
.help-block {
    color: #dd4b39;
}
</style>



// WEBPACK FOOTER //
// Etiqueta.vue?62a06b9f